(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["autoplay-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('autoplay-card-slider')) {
    customElements.define(
      'autoplay-card-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          if (this.slides.length < 2) return;

          this.index = 0;
          this.hovered = false;
          this.focused = false;
          this.touching = false;

          // The active segment's fill is the timer: when its animation finishes, the next slide shows.
          // Pausing the animation pauses autoplay, and it resumes from the same point.
          this.nav = this.querySelector('[data-nav]');
          this.fills = this.dots.map((dot) => dot.querySelector('[data-fill]'));

          const reduce =
            this.hasAttribute('data-respect-reduced-motion') &&
            window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.autoplay = !reduce && !!this.nav && this.fills.length === this.slides.length && this.fills.every(Boolean);

          if (!this.autoplay) {
            if (this.nav) this.nav.classList.add('is-static');
          } else {
            this.onProgressEnd = (e) => {
              if (e.animationName !== 'ac-progress' || e.target !== this.fills[this.index]) return;
              this.show(this.index + 1);
              this.startCycle();
            };
            this.nav.addEventListener('animationend', this.onProgressEnd);
          }

          this.dots.forEach((dot, n) =>
            dot.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              this.show(n);
              this.startCycle();
            })
          );

          // Pause while the mouse is anywhere over the card (including the text and button)
          this.hoverRoot = this.closest('.image-card') || this;
          this.onEnter = (e) => {
            if (e.pointerType !== 'mouse') return;
            this.hovered = true;
            this.updatePlayState();
          };
          this.onLeave = (e) => {
            if (e.pointerType !== 'mouse') return;
            this.hovered = false;
            this.updatePlayState();
          };
          this.hoverRoot.addEventListener('pointerenter', this.onEnter);
          this.hoverRoot.addEventListener('pointerleave', this.onLeave);

          // Pause while keyboard focus is on the dots (not after a mouse click or tap,
          // which would otherwise leave autoplay stuck until the visitor clicked elsewhere)
          this.addEventListener('focusin', (e) => {
            if (!e.target.matches(':focus-visible')) return;
            this.focused = true;
            this.updatePlayState();
          });
          this.addEventListener('focusout', (e) => {
            if (this.contains(e.relatedTarget)) return;
            this.focused = false;
            this.updatePlayState();
          });

          // Pause when the browser tab is in the background
          this.onVisibility = () => this.updatePlayState();
          document.addEventListener('visibilitychange', this.onVisibility);

          this.setupSwipe();
          this.startCycle();
        }

        // Swipe left/right on touch screens, anywhere over the card
        setupSwipe() {
          let startX = 0;
          let startY = 0;
          let tracking = false;

          this.onTouchStart = (e) => {
            if (e.touches.length !== 1) {
              tracking = false;
              return;
            }
            tracking = true;
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
            this.touching = true;
            this.updatePlayState();
          };

          this.onTouchEnd = (e) => {
            this.touching = false;
            if (!tracking) {
              this.updatePlayState();
              return;
            }
            tracking = false;
            const touch = e.changedTouches[0];
            const dx = touch.clientX - startX;
            const dy = touch.clientY - startY;

            // Only count clearly horizontal swipes, so vertical page scrolling is unaffected
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
              this.classList.add('is-swiped');
              this.show(this.index + (dx < 0 ? 1 : -1));
              clearTimeout(this.swipeTimer);
              this.swipeTimer = setTimeout(() => this.classList.remove('is-swiped'), 500);
              this.startCycle();
            } else {
              this.updatePlayState();
            }
          };

          this.onTouchCancel = () => {
            tracking = false;
            this.touching = false;
            this.updatePlayState();
          };

          this.hoverRoot.addEventListener('touchstart', this.onTouchStart, { passive: true });
          this.hoverRoot.addEventListener('touchend', this.onTouchEnd, { passive: true });
          this.hoverRoot.addEventListener('touchcancel', this.onTouchCancel, { passive: true });
        }

        disconnectedCallback() {
          if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
          if (this.nav && this.onProgressEnd) this.nav.removeEventListener('animationend', this.onProgressEnd);
          if (this.hoverRoot) {
            this.hoverRoot.removeEventListener('pointerenter', this.onEnter);
            this.hoverRoot.removeEventListener('pointerleave', this.onLeave);
            this.hoverRoot.removeEventListener('touchstart', this.onTouchStart);
            this.hoverRoot.removeEventListener('touchend', this.onTouchEnd);
            this.hoverRoot.removeEventListener('touchcancel', this.onTouchCancel);
          }
          clearTimeout(this.swipeTimer);
        }

        show(n) {
          this.index = (n + this.slides.length) % this.slides.length;
          this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.index));
          this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
        }

        // Fill the active segment from empty (on load, after each slide change, and after a tap or swipe)
        startCycle() {
          if (!this.autoplay) return;
          this.fills.forEach((fill) => fill.classList.remove('is-running', 'is-paused'));
          const fill = this.fills[this.index];
          void fill.offsetWidth; // restart the CSS animation
          fill.classList.add('is-running');
          this.updatePlayState();
        }

        // Pause or resume the active segment (and therefore autoplay) without resetting it
        updatePlayState() {
          if (!this.autoplay) return;
          const paused = this.hovered || this.focused || this.touching || document.hidden;
          this.fills[this.index].classList.toggle('is-paused', paused);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
